import { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";
import { routeConstants } from "services/keyConstants";

// render - pages
const YearWiseList = Loadable(lazy(() => import("../YearWiseList")));
const EvaluationList = Loadable(lazy(() => import("../EvaluationList")));
const TrainingCalender = Loadable(lazy(() => import("../TrainingCalender")));
const ListOfEmployees = Loadable(lazy(() => import("../ListOfEmployees")));
const TrainingAttendanceSheet = Loadable(
  lazy(() => import("../TrainingAttendanceSheet"))
);
const TrainingAttendanceSheetList = Loadable(
  lazy(() => import("../TrainingAttendanceSheetList"))
);
const EvaluationByAttendanceSheet = Loadable(
  lazy(() => import("../EvaluationByAttendanceSheet"))
);
const RequisitionforManPower = Loadable(
  lazy(() => import("../RequisitionforManPower"))
);
const QuestionPaper = Loadable(lazy(() => import("../QuestionPaper")));
const RequisitionManPowerForm = Loadable(
  lazy(() => import("../RequisitionManPowerForm"))
);
const CompetencyMatrix = Loadable(lazy(() => import("../CompetencyMatrix")));
const TrainingNeedAssesmentList = Loadable(
  lazy(() => import("../TrainingNeedAssesmentList"))
);
const TrainingNeedAssessmentForm = Loadable(
  lazy(() => import("../TrainingNeedAssessmentForm"))
);
const CATRecord = Loadable(lazy(() => import("../CATRecordList")));
const CATFilledRecordsList = Loadable(
  lazy(() => import("../CATFilledRecordsList"))
);
const InductionTrainingRecordList = Loadable(
  lazy(() => import("../InductionTrainingRecordList"))
);
const CreateInductionTraining = Loadable(
  lazy(() => import("../CreateInductionTraining"))
);

// ==============================|| PAGE ROUTES ||============================== //

const catNewRoutes = [
  {
    path: routeConstants.CAT,
    children: [
      { path: "records-list/:id", element: <CATRecord /> },
      {
        path: "evaluation-list/:attendanceId/:calendarId/:rowId",
        element: <EvaluationByAttendanceSheet />,
      },
      { path: "records/evaluation-list", element: <EvaluationList /> },
      { path: "records/:defaultName", element: <CATFilledRecordsList /> },
      { path: "records/competency-matrix", element: <CompetencyMatrix /> },
      {
        path: "induction-training-record/create",
        element: <CreateInductionTraining />,
      },
      {
        path: "records/induction-training-record",
        element: <InductionTrainingRecordList />,
      },
      {
        path: "records/manpower-requisition",
        element: <RequisitionforManPower />,
      },
      { path: "records/manpower-form", element: <RequisitionManPowerForm /> },
      {
        path: "records/training-need-assessment",
        element: <TrainingNeedAssesmentList />,
      },
      {
        path: "records/training-need-assessmentForm",
        element: <TrainingNeedAssessmentForm />,
      },
      { path: "records/list-of-employee", element: <ListOfEmployees /> },
      { path: "records/year-wise", element: <YearWiseList /> },
      { path: "records/training-calender/:id", element: <TrainingCalender /> },
      {
        path: "records/training-attandance-sheet",
        element: <TrainingAttendanceSheetList />,
      },
      {
        path: "training-attandance-sheet/:id",
        element: <TrainingAttendanceSheet />,
      },
      { path: "question-paper/:tcId/:rowId", element: <QuestionPaper /> },
    ],
  },
];

export default catNewRoutes;
